import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CreditPackForm from '../components/forms/credit-pack-form';

const CreditPacksFormRoute: FC = () => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const navigate = useNavigate()

  return (
    <>
      <PageHeader
        title="فرم پکیج"
        onBack={() => navigate(-1)}
 
        style={{ padding: " 16px 0" }}
        />
      <Card >
        <CreditPackForm id={id} />
      </Card>
    </>
  );
}

export default CreditPacksFormRoute;
